// extracted by mini-css-extract-plugin
export var borderRadius = "_c4-4";
export var large = "_c4-3";
export var logoContainer = "_c4-0";
export var nameLogo = "_c4-2";
export var small = "_c4-1";